
<div class="user-form-max-width full-height grid-container v-pad">
  <h2>Signature</h2>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12">
      <div class="signature-line">{{signer.dateSigned | date}}</div>
      <div class="small-font-size italic">Date</div>
    </div>
    <div class="cell small-12">
      <div class="signature-line">
        <div>{{signer.legalName}}</div>
      </div>
      <ng-container>
        @if (!hasAuthority) {
          <div class="error-text normal">No signing authority for this document.</div>
        }
      </ng-container>
      <div [style.display]="showSignatureError ? 'block' : 'none'" class="error-text normal">{{signatureError}}</div>

      <div class="small-font-size italic">
        @if (isDelegateSignature) {
          <span>{{signer.authority}} {{signer.legalName}} for </span>
        }
        @if (chief) {
          <span>{{chief[0].fullLegalName}}, Chief of the </span>
        } @else {
          Loading ...
        }
        <span>Division of Oil and Gas Resource Management</span>
      </div>
      <div class="form-button-group">
        <button (click)="sign()" class="button hollow" title="Affix Signature">
          <span class="show-for-sr">Affix Signature</span>
          <span aria-hidden="true" class="minor-margin-right">Sign</span>
          <svg-icon icon="icon-signature" class="tiny light-blue" aria-hidden="true"></svg-icon>
        </button>
      </div>
    </div>
  </div>
</div>


